import { Box, Typography } from "@mui/material";
import { Moment } from "moment";
import { CALENDAR_DATE_FORMAT } from "../../../../constants";

type CalendarDayHeaderProps = {
  days: Moment[];
  today: string;
  gridTemplateColumns: string;
  label?: string;
  onDayClick?: (day: Moment) => void;
};

export const CalendarDayHeader = ({
  days,
  today,
  gridTemplateColumns,
  label,
  onDayClick,
}: CalendarDayHeaderProps) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns,
      borderBottom: "1px solid var(--dashboard-border-divider)",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-end", px: 2, pb: 1 }}>
      {label && (
        <Typography className="dashboard-metric-label">{label}</Typography>
      )}
    </Box>
    {days.map((day) => {
      const isToday = day.format(CALENDAR_DATE_FORMAT) === today;

      return (
        <Box
          key={day.format(CALENDAR_DATE_FORMAT)}
          role={onDayClick ? "button" : undefined}
          tabIndex={onDayClick ? 0 : undefined}
          onClick={() => onDayClick?.(day)}
          onKeyDown={(e) => {
            if (onDayClick && (e.key === "Enter" || e.key === " ")) {
              e.preventDefault();
              onDayClick(day);
            }
          }}
          sx={{
            py: 1,
            px: days.length === 1 ? 2 : 0,
            textAlign: days.length === 1 ? "left" : "center",
            cursor: onDayClick ? "pointer" : "default",
            borderLeft: "1px solid var(--dashboard-border-row)",
            backgroundColor: isToday
              ? "var(--dashboard-info-light)"
              : "transparent",
          }}
        >
          <Typography className="dashboard-metric-label">
            {day.format("ddd")}
          </Typography>
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 700,
              color: isToday
                ? "var(--dashboard-info)"
                : "var(--dashboard-text-primary)",
            }}
          >
            {day.format("D")}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
